import { Component, h, Prop } from '@stencil/core'
import './udp-calendar-day.css'

@Component({
  tag: 'udp-calendar-day',
  styleUrl: 'udp-calendar-day.css',
  shadow: true,
})
export class UdpCalendarDay {
  @Prop() props: any = {}

  componentWillLoad() { 
    
  }

  render() {
    return (
      <udp-calendar-base initialView='dayGridDay' {...this.props}></udp-calendar-base>
    )
  }
}
